import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Card, CardBody, Modal, ModalHeader, ModalBody } from 'reactstrap';
import LoadingOverlay from 'react-loading-overlay-ts';
import DNALoader from '../../components/Loaders/DnaLoader';
import Alerts from '../../components/Alerts/alerts';
import ItemsService from "./Item.service.js";

const UpdateStockModal = ({ showModal, handleToggleModal, onSuccess, sessionID, stockData }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    stock_id: '',
    item_id: '',
    business_id: '',
    pharmacy_id: '',
    quantity: '',
    price: '',
    expiry_date: '',
    status: 'Active'
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (stockData) {
      setData({
        stock_id: stockData._id,
        item_id: stockData.item_id,
        business_id: stockData.business_id,
        pharmacy_id: stockData.pharmacy_id,
        quantity: stockData.quantity,
        price: stockData.price,
        expiry_date: stockData.expiry_date,
        status: stockData.status
      });
    }
  }, [stockData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!data.quantity) newErrors.quantity = 'Quantity is required';
    if (!data.price) newErrors.price = 'Price is required';
    if (!data.expiry_date) newErrors.expiry_date = 'Expiry date is required';
    if (!data.status) newErrors.status = 'Status is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setLoading(true);
    try {
      const response = await ItemsService.UpdateStock(sessionID, data);
      setLoading(false);
      if (response.data.status === true) {
        Alerts.swalSuccessAlert(t('Stock updated successfully.'));
        onSuccess();
        handleToggleModal();
      } else {
        Alerts.swalErrorAlert(response.data.message || t('Failed to update stock.'));
      }
    } catch (error) {
      setLoading(false);
      Alerts.swalErrorAlert(t('An error occurred. Please try again.'));
      console.error('Error updating stock:', error);
    }
  };

  return (
    <Modal isOpen={showModal} toggle={handleToggleModal}>
      <ModalHeader toggle={handleToggleModal}>{t('Update Stock')}</ModalHeader>
      <ModalBody>
        <Col md="12">
          <Card className="main-card mb-3">
            <CardBody>
              <LoadingOverlay
                active={loading}
                spinner={<DNALoader />}
              >
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-12 mt-3">
                      <div className="form-group">
                        <label>{t('Quantity')}</label>
                        <input
                          placeholder='Enter Quantity'
                          type="number"
                          className="form-control"
                          name="quantity"
                          value={data.quantity}
                          onChange={handleChange}
                        />
                        {errors.quantity && <span className="error text-danger">{errors.quantity}</span>}
                      </div>
                    </div>

                    <div className="col-md-12 mt-3">
                      <div className="form-group">
                        <label>{t('Price')}</label>
                        <input
                          placeholder='Enter Price'
                          type="number"
                          step="0.01"
                          className="form-control"
                          name="price"
                          value={data.price}
                          onChange={handleChange}
                        />
                        {errors.price && <span className="error text-danger">{errors.price}</span>}
                      </div>
                    </div>

                    <div className="col-md-12 mt-3">
                      <div className="form-group">
                        <label>{t('Expiry Date')}</label>
                        <input
                          type="date"
                          className="form-control"
                          name="expiry_date"
                          value={data.expiry_date}
                          onChange={handleChange}
                        />
                        {errors.expiry_date && <span className="error text-danger">{errors.expiry_date}</span>}
                      </div>
                    </div>

                    <div className="col-md-12 mt-3">
                      <div className="form-group">
                        <label>{t('Status')}</label>
                        <select
                          className="form-control"
                          name="status"
                          value={data.status}
                          onChange={handleChange}
                        >
                          <option value="Active">Active</option>
                          <option value="InActive">InActive</option>
                        </select>
                        {errors.status && <span className="error text-danger">{errors.status}</span>}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12 text-center mt-3">
                      <button type="button" className="btn btn-outline-light btn-hover-shine me-3" onClick={handleToggleModal}>
                        {t('Close')}
                      </button>
                      <button type="submit" className="btn btn-custom-color">
                        {t('Update Stock')}
                      </button>
                    </div>
                  </div>
                </form>
              </LoadingOverlay>
            </CardBody>
          </Card>
        </Col>
      </ModalBody>
    </Modal>
  );
};

export default UpdateStockModal;